export enum PolygonType {
  Standard = 'standard',
  Extended = 'extended',
  Mov = 'mov',
}
